import React, { useState } from 'react';
import { X, Play, Clock, Sparkles, Video, Lock } from 'lucide-react';
interface VideoGenerationUpsellProps {
  discreet?: boolean;
  inline?: boolean;
  onClose?: () => void;
  onPurchase?: (duration: number, tokens: number) => void;
}
export const VideoGenerationUpsell: React.FC<VideoGenerationUpsellProps> = ({
  discreet = false,
  inline = false,
  onClose,
  onPurchase
}) => {
  const [selectedOption, setSelectedOption] = useState<5 | 10 | null>(null);
  const handlePurchase = () => {
    if (selectedOption === 5) {
      onPurchase?.(5, 12);
    } else if (selectedOption === 10) {
      onPurchase?.(10, 20);
    }
  };
  if (discreet) {
    return <div className="p-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-of-blue dark:hover:border-of-blue transition-all cursor-pointer shadow-sm" data-id="element-22359">
        <div className="flex items-center gap-2" data-id="element-22360">
          <div className="w-8 h-8 flex items-center justify-center bg-of-blue/10 dark:bg-of-blue/20 rounded-full text-of-blue" data-id="element-22361">
            <Video size={16} data-id="element-22362" />
          </div>
          <div className="flex-1" data-id="element-22363">
            <p className="text-xs text-gray-700 dark:text-gray-200" data-id="element-22364">
              <span className="text-of-blue" data-id="element-22365">New!</span> Generate custom videos
            </p>
            <div className="flex items-center text-xs text-gray-500 dark:text-gray-400" data-id="element-22366">
              <span data-id="element-22367">From 12 💎</span>
              <span className="ml-auto text-of-blue text-xs" data-id="element-22368">Try now →</span>
            </div>
          </div>
        </div>
      </div>;
  }
  if (inline) {
    return <div className="p-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm" data-id="element-22369">
        <div className="flex items-center gap-2" data-id="element-22370">
          <div className="w-10 h-10 flex items-center justify-center bg-of-blue/10 dark:bg-of-blue/20 rounded-full text-of-blue" data-id="element-22371">
            <Video size={20} data-id="element-22372" />
          </div>
          <div className="flex-1" data-id="element-22373">
            <h3 className="text-sm font-medium text-gray-800 dark:text-gray-200" data-id="element-22374">
              Generate Custom Videos
            </h3>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-22375">
              5s video for 12 💎 or 10s video for 20 💎
            </p>
          </div>
          <button className="px-3 py-1.5 bg-of-blue rounded-full text-white text-xs font-medium" data-id="element-22376">
            Generate Now
          </button>
        </div>
      </div>;
  }
  return <div className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden animate-in zoom-in-90 duration-300 shadow-lg" data-id="element-22377">
      <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center" data-id="element-22378">
        <h3 className="font-bold flex items-center gap-2 text-gray-800 dark:text-white" data-id="element-22379">
          <Video size={18} className="text-of-blue" data-id="element-22380" />
          Generate Custom Video
        </h3>
        {onClose && <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400" data-id="element-22381">
            <X size={18} data-id="element-22382" />
          </button>}
      </div>
      <div className="p-4" data-id="element-22383">
        <div className="relative rounded-lg overflow-hidden mb-4 border border-gray-200 dark:border-gray-700" data-id="element-22384">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg" alt="Video preview" className="w-full h-48 object-cover blur-sm" data-id="element-22385" />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/50 dark:bg-gray-900/50 backdrop-blur-sm" data-id="element-22386">
            <div className="w-16 h-16 rounded-full bg-of-blue/20 flex items-center justify-center mb-2" data-id="element-22387">
              <Play size={32} className="text-of-blue ml-1" data-id="element-22388" />
            </div>
            <p className="text-center text-gray-800 dark:text-white font-medium" data-id="element-22389">
              Generate your custom video
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-22390">
              Choose length and unlock now
            </p>
          </div>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4" data-id="element-22391">
          Generate a custom video with your favorite angel. Choose your
          preferred duration:
        </p>
        <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-22392">
          <button className={`p-3 rounded-lg border flex flex-col items-center transition-all ${selectedOption === 5 ? 'border-of-blue bg-of-blue/10 text-gray-800 dark:text-white' : 'border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 hover:border-of-blue/50 text-gray-700 dark:text-gray-300'}`} onClick={() => setSelectedOption(5)} data-id="element-22393">
            <Clock size={20} className="text-of-blue mb-1" data-id="element-22394" />
            <span className="font-medium" data-id="element-22395">5 Seconds</span>
            <span className="text-sm text-of-blue mt-1" data-id="element-22396">12 💎</span>
          </button>
          <button className={`p-3 rounded-lg border flex flex-col items-center transition-all ${selectedOption === 10 ? 'border-of-blue bg-of-blue/10 text-gray-800 dark:text-white' : 'border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 hover:border-of-blue/50 text-gray-700 dark:text-gray-300'}`} onClick={() => setSelectedOption(10)} data-id="element-22397">
            <Clock size={20} className="text-of-blue mb-1" data-id="element-22398" />
            <span className="font-medium" data-id="element-22399">10 Seconds</span>
            <div className="flex items-center mt-1" data-id="element-22400">
              <span className="text-sm text-of-blue" data-id="element-22401">20 💎</span>
              <span className="ml-1 text-xs bg-of-blue text-white px-1 rounded" data-id="element-22402">
                BEST VALUE
              </span>
            </div>
          </button>
        </div>
        <div className="flex items-center justify-between p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg mb-4 border border-blue-100 dark:border-blue-800/30" data-id="element-22403">
          <div className="flex items-center gap-1" data-id="element-22404">
            <Sparkles size={14} className="text-yellow-500" data-id="element-22405" />
            <span className="text-xs text-gray-700 dark:text-gray-300" data-id="element-22406">
              First time? Get 30% off!
            </span>
          </div>
          <span className="text-xs text-of-blue" data-id="element-22407">Limited time offer</span>
        </div>
        <button className={`w-full py-2 rounded-lg text-white text-sm font-medium ${selectedOption ? 'bg-of-blue hover:bg-of-blue-dark transition-colors' : 'bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400'}`} disabled={!selectedOption} onClick={handlePurchase} data-id="element-22408">
          {selectedOption ? `Generate ${selectedOption}s Video for ${selectedOption === 5 ? '12' : '20'} 💎` : 'Select an option'}
        </button>
      </div>
    </div>;
};